import {LayoutComponent} from "../layout/layout.component";
import {RouterModule, Routes} from "@angular/router";
import {NgModule} from "@angular/core";
import {KontakDataKantorComponent} from "./kontak-data-kantor.component";

const routes: Routes = [
  {
    path: 'kontak-data-kantor',
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: KontakDataKantorComponent,
      }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class KontakDataKantorRoutingModule { }
